// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// Hooks
import {
    addListenerForPushNotificationRegistration,
    addListenerToTriggerNotificationRegistrationFlow,
} from '../../notifications/push/mobileNotificationsUtils';

// Constants
import { CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

// Plugins
import { PushNotificationsPlugin } from '../../../capacitor_plugins/pushNotifications';

export default function () {
    useEffect(() => {
        (async () => {
            await addListenerForPushNotificationRegistration();
            await addListenerToTriggerNotificationRegistrationFlow();

            if (Capacitor.isPluginAvailable(CAPACITOR_PUSH_NOTIFICATIONS_PLUGIN)) {
                // Run the registration logic whenever we open a new workspace
                PushNotificationsPlugin.registerOnDevice();
            }
        })();
    }, []);
}
